import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { Color } from '../../util/color-calculator';
import { Icon, IconSource } from '../Icon/Icon';

type Size = 'medium' | 'extra-large';

interface Props {
	source: IconSource;
	color?: Color;
	size?: Size;
}

const getColor = (color?: Color) => {
	switch (color) {
		case 'red':
			return tw`border-red-100 bg-red-200 text-red-500`;
		case 'yellow':
			return tw`border-yellow-100 bg-yellow-200 text-yellow-700`;
		case 'green':
			return tw`border-green-100 bg-green-200 text-green-500`;
		case 'blue':
			return tw`border-blue-100 bg-blue-200 text-blue-500`;
		case 'indigo':
			return tw`border-indigo-100 bg-indigo-200 text-indigo-500`;
		default:
			return tw`border-gray-100 bg-gray-200 text-gray-500`;
	}
};

const getSize = (size: Size) => {
	switch (size) {
		case 'medium':
			return tw`size-14 border-8`;
		case 'extra-large':
			return tw`size-28 border-[16px]`;
	}
};

export const StyledColoredCircle = styled.span<{ color: Color; size: Size }>`
	${tw`inline-flex items-center justify-center rounded-full border-solid`}
	${({ color }) => getColor(color)}
	${({ size }) => getSize(size)}
`;

export const ColoredCircleIcon: FC<Props> = ({ source, color = 'indigo', size = 'medium', ...rest }) => (
	<StyledColoredCircle color={color} size={size}>
		<Icon source={source} color="currentColor" size={size === 'extra-large' ? 'large' : 'medium'} {...rest} />
	</StyledColoredCircle>
);
